import request from '@/utils/request'
const qs = require('qs')
export function androidInofarmaVersion(data) {
  return request({
    url: '/version/android_inofarma_version',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}
export function grandTotalPenjualanBulanIni(data) {
  return request({
    url: '/dashboard/grand_total_penjualan_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function grandTotalPiutangBulanIni(data) {
  return request({
    url: '/dashboard/grand_total_piutang_penjualan_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function grandTotalHutangJatuhTempoBulanIni(data) {
  return request({
    url: '/dashboard/grand_total_hutang_jatuh_tempo_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalPelangganAktif(data) {
  return request({
    url: '/dashboard/total_pelanggan_aktif',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTransaksiPenjualan(data) {
  return request({
    url: '/dashboard/total_transaksi_penjualan',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalDefecta(data) {
  return request({
    url: '/dashboard/total_defecta',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalNoStockNoExpired(data) {
  return request({
    url: '/dashboard/total_no_stock_no_expired',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalLabaBersih(data) {
  return request({
    url: '/dashboard/grand_total_laba_bersih_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}
export function totalLabaKotor(data) {
  return request({
    url: '/dashboard/grand_total_laba_kotor_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js